var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Dashboard")]),(_vm.settings.mfa_required || _vm.user.require_password_reset)?_c('action-required'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }